import { useMemo } from 'react';
import { useAppSelector } from '../../redux/ReduxHooks';
import { RobotActions } from '../../utils/constants';
import { isSaveSlotEmpty, type SaveSlotLike } from '../../utils/saveSlotProjectId';

/**
 * Keeps the Connected Drawer user-programs section in a loading state until the
 * current connection finishes its slot-metadata query. Once the query completes,
 * cached slot data may still be stale, but the drawer should stop presenting the
 * section as busy forever.
 */
export default function useUserProgramsSlotLoading() {
  const robotState = useAppSelector((state) => state.robot.robotState);
  const slotStorage = useAppSelector((state) => state.robotData.slotStorage);
  const slotStorageReady = useAppSelector((state) => state.robotData.slotStorageReady);

  const hasVisibleSlotPrograms = useMemo(
    () => slotStorage !== null && Object.values(slotStorage).some((slot) => !isSaveSlotEmpty(slot as SaveSlotLike)),
    [slotStorage]
  );

  const isUserProgramsLoading = robotState === RobotActions.STATE.CONNECTED && !slotStorageReady;

  return { hasVisibleSlotPrograms, isUserProgramsLoading };
}
